import React from 'react';
import { useIntl } from 'react-intl';
import { Form, Checkbox as AntDCheckbox } from 'antd';
import { constructValidationRules } from './validations';

const CheckboxGroup: React.FC<any> = ({isFormItem = true, name, label, style, customLayout, validation = {}, customRules, ...props}) => {
    const intl = useIntl();

    let labelCol: any = { span: 8 };
    let wrapperCol: any = { span: 6 };

    if (customLayout) {
        if (typeof customLayout === 'object') {
            labelCol = customLayout.labelCol || undefined;
            wrapperCol = customLayout.wrapperCol || undefined;
        } else {
            labelCol = undefined;
            wrapperCol = undefined;
        }
    }

    return isFormItem ? (
        <Form.Item
            name={name}
            label={label}
            labelCol={labelCol}
            wrapperCol={wrapperCol}
            style={style}
            rules={customRules || constructValidationRules(validation, intl)}
        >
            <AntDCheckbox.Group {...props} />
        </Form.Item>
    ) : (
        <AntDCheckbox.Group style={style} {...props} />
    )
}

export default CheckboxGroup;
